import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.TasaImpuestos;
export interface Props {
    value: Entity;
    readonly?: boolean;
    onChange: (value: Entity) => PromiseLike<void>;
}

/**
* Componente para editar un Entity
*/
export class TasaImpuestosComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    readonly = (x: Props) => x.readonly;

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Number = getField(kea.Number);
        const readonly = this.readonly(this.props);

        return (
            <kea.Panel title="Tasas de impuestos" >
                {kea.autogrid(6, [
                    <Number field="TasaIva" format="percentage" label="Tasa IVA" readonly={readonly} />,
                    <Number field="RetencionIvaPersonaFisica" format="percentage" label="Retención de IVA para personas físicas" readonly={readonly} />,
                    <Number field="RetencionIvaPersonaMoral" format="percentage" label="Retención de IVA para personas morales" readonly={readonly} />,
                ])}
            </kea.Panel>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/impuestos.tsx